import PROFILES from './profiles';
import NOTIFICATIONS from './notification-types';
import COMPONENT_EVENTS from './componentEvents';
import INITIAL_STATUS from './initialStatus';

export const DEFAULT_MAP_OPTIONS = google => ({
  center: { lat: 0, lng: 0 },
  zoomControlOptions: {
    position: google.maps.ControlPosition.RIGHT_CENTER,
  },
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false,
});

export { default as PROFILES } from './profiles';
export { default as NOTIFICATIONS } from './notification-types';
export { default as COMPONENT_EVENTS } from './componentEvents';
export { default as INITIAL_STATUS } from './initialStatus';

export default {
  DEFAULT_MAP_OPTIONS,
  PROFILES,
  NOTIFICATIONS,
  COMPONENT_EVENTS,
  INITIAL_STATUS,
};
